"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { WorkspaceContent, WorkspaceContentFallback } from "./WorkspaceContent";
import { WorkspaceFolders, WorkspaceFoldersFallback } from "./WorkspaceFolders";
import { WorkspaceHeader, WorkspaceHeaderFallback } from "./WorkspaceHeader";
interface WorkspaceProps {
  readonly folderId?: string;
}
export const Workspace: FC<WorkspaceProps> = t0 => {
  const $ = _c(2);
  const {
    folderId
  } = t0;
  let t1;
  if ($[0] !== folderId) {
    t1 = <><WorkspaceHeader folderId={folderId} /><WorkspaceFolders folderId={folderId} /><WorkspaceContent folderId={folderId} /></>;
    $[0] = folderId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const WorkspaceFallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><WorkspaceHeaderFallback /><WorkspaceFoldersFallback /><WorkspaceContentFallback /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};